export function openFeedbackForm() {
  let feedbackform = document.getElementById('feedback_form');
  let body = document.querySelector('body');

  feedbackform.classList.toggle('show');
  feedbackform.classList.toggle('fullscreen');
  let ariaHiddenAttr = feedbackform.getAttribute('aria-hidden');
  body.classList.add('stop-scroll');

  feedbackform.setAttribute(
    'aria-hidden',
    ariaHiddenAttr == 'true' ? false : true
  );
  feedbackform.setAttribute(
    'aria-live',
    ariaHiddenAttr == 'true' ? 'polite' : 'off'
  );
}

export function closeFeedbackForm() {
  let feedbackform = document.getElementById('feedback_form');
  let body = document.querySelector('body');

  feedbackform.classList.remove('show');
  feedbackform.classList.remove('fullscreen');
  body.classList.remove('stop-scroll');

  feedbackform.setAttribute('aria-hidden', true);
  feedbackform.setAttribute('aria-live', 'off');
}
